import React, { useEffect, useState } from "react";
import SunburstChart from "../../../CHARTS/SunburstChart";
const SunBurst = ({ data, keyName }) => {
  const [chartData, setChartData] = useState(null);
  const [length, setLength] = useState(0);
  const [fYear, setFYear] = useState(null);
  function colorGenerator(baseKey, level) {
    const baseColors = {
      Other: "#3498db",
      CEMT: "#9D65D1",
      CLKR: "#f39c12",
      CONT: "#e74c3c",
      FERT: "#F6FA2B",
      FG: "#16EE69",
      ORES: "#7F79DB",
      RMSP: "#ffcc00",
      COAL: "#66ccff",
    };

    const shadeAdjust = ["", "B3", "99", "66", "33"]; // alpha transparency for demo
    const base = baseColors[baseKey] || "#888888";
    return base + (shadeAdjust[level] || "");
  }
  const transformToChartData = () => {
    if (!data) return;
    const chartData = [];

    data.forEach(({ commodities_data }) => {
      commodities_data.forEach(
        ({ GROUP_COMMODITY, group_commodities_data }) => {
          const groupColor = colorGenerator(GROUP_COMMODITY, 0);
          const groupNode = {
            name: GROUP_COMMODITY,
            itemStyle: { color: groupColor },
            children: [],
          };

          group_commodities_data.forEach(
            ({ SUB_GROUP_COMMODITY, sub_commodities_data }) => {
              const subGroupColor = colorGenerator(GROUP_COMMODITY, 1);
              const subGroupNode = {
                name: SUB_GROUP_COMMODITY,
                itemStyle: { color: subGroupColor },
                children: [],
              };

              sub_commodities_data.forEach(({ COMMODITY, months_data }) => {
                const commodityColor = colorGenerator(GROUP_COMMODITY, 2);
                const commodityNode = {
                  name: COMMODITY,
                  itemStyle: { color: commodityColor },
                  children: [],
                };

                // Aggregate [keyName]s by FROM_STN
                const fromStnMap = {};

                months_data.forEach(({ data }) => {
                  data.forEach((record) => {
                    const fromStn = record.FROM_STN;
                    const keyNameVal = parseFloat(record[keyName]) || 0;

                    if (!fromStnMap[fromStn]) {
                      fromStnMap[fromStn] = 0;
                    }

                    fromStnMap[fromStn] += keyNameVal;
                  });
                });

                // Convert to children nodes
                Object.entries(fromStnMap).forEach(
                  ([fromStn, totalKeyName], idx) => {
                    const stationColor = colorGenerator(
                      GROUP_COMMODITY,
                      3 + (idx % 3)
                    ); // shade based on index
                    commodityNode.children.push({
                      name: fromStn,
                      value: parseFloat(totalKeyName.toFixed(2)),
                      text: parseFloat(totalKeyName.toFixed(2)),
                      itemStyle: { color: stationColor },
                    });
                  }
                );

                if (commodityNode.children.length > 0) {
                  subGroupNode.children.push(commodityNode);
                }
              });

              if (subGroupNode.children.length > 0) {
                groupNode.children.push(subGroupNode);
              }
            }
          );

          if (groupNode.children.length > 0) {
            chartData.push(groupNode);
          }
        }
      );
    });

    return chartData;
  };

  useEffect(() => {
    setLength(0);
    const sunBurstData = transformToChartData();
    setChartData(sunBurstData);
    setLength(data[0]?.commodities_data?.length);
    setFYear(data[0].F_YEAR);
  }, [data, data[0].F_YEAR]);

  return (
    <div>
      <h6 className="bg-dark text-white p-1">
        {" "}
        {keyName === "WAGON" ? "Wagon" : "CH Weight"} Wise Data
      </h6>
      {chartData && (
        <SunburstChart
          data={chartData}
          from={keyName}
          length={length}
          fYear={fYear}
        />
      )}
    </div>
  );
};
export default SunBurst;
